module.exports = __webpack_public_path__ + "img/cover_.427036d3.jpg";